import { toast } from "react-toastify";
import { hospitalDataConstants } from "../../_constants";
import { getCentralHospitalListService } from "../../_services";
import { alertActions } from "../alert.actions";
import { configActions } from "../config.actions";

function getCentralHospitalList(params) {
    return (dispatch,getState) => {
      dispatch(request());
      dispatch(configActions.showSpinningLoader());
      getCentralHospitalListService(params).then(
          (res) => {
            dispatch(success(res));
            dispatch(configActions.hideSpinningLoader());
        // !!res?.description && toast.success(res.description)
  
          },
          (error) => {
        toast.error(error.description)
            dispatch(failure(error));
            dispatch(alertActions.error(error));
          }
        );
        dispatch(configActions.hideSpinningLoader());
    };
  
    function request() {
      return {
        type: hospitalDataConstants.FETCH_HOSPITAL_DATA_REQUESTING,
      };
    }
    function success(res) {
      return {
        type: hospitalDataConstants.FETCH_HOSPITAL_DATA_FETCHED,
        listData: res.result.reportingCounts,
      };
    }
    function failure(error) {
      return { type: hospitalDataConstants.FETCH_HOSPITAL_DATA_FAILED, error };
    }
  }

export const centralHospitalActions = {
    getCentralHospitalList,
};
